import React, { useEffect } from "react";
import { Card, Link } from "@mui/material";
import Grid from "@mui/material/Grid";
import enGB from "date-fns/locale/en-GB";
import { useDispatch, useSelector } from "react-redux";
import { orderdata_fetchData, orderdata_updateGroupOrderForDay } from "reducers/orderdata/orderdata";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import GroupOrdersDayMenu from "./GroupOrdersDayMenu";
import Button from "@mui/material/Button";
import { calculateCurrentWeek } from "../Schedule/ScheduleHelper";
import GroupOrdersDayMenuFlat from "./GroupOrdersDayMenuFlat";
import { getUser } from "services/auth";
import { scheduledataSelector } from "reducers/scheduledata/scheduledata";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3
};

function GroupOrdersDay(props) {
  const user = getUser();
  const order_time_limit = user && user["isAdmin"] ? 12 : 11;
  const dispatch = useDispatch();
  const scheduledata = useSelector(scheduledataSelector);
  const ordersAvailable = props.orders;
  const weekdays = [...Array(5).keys()].map(i => enGB.localize.day(i + 1));
  const [open, setOpen] = React.useState(false);
  const [allergiesForMenu, setAllergiesForMenu] = React.useState({});
  const [dayDisabled, setDayDisabled] = React.useState(false);
  const [timeLeftToday, setTimeLeftToday] = React.useState(60);
  const [timeNeedsUpdate, setTimeNeedsUpdate] = React.useState(false);
  const [disableDayOnTimer, setDisableDayOnTimer] = React.useState(false);

  // WARNING
  // WARNING
  // WARNING
  // WARNING
  // the timeleft today constant is updated every second
  // that means...
  // in react, this element (and its children) gets updated every second
  // that does not seem to be a problem in the app
  // but it would be nice to change this functionality...
  // END WARNING
  // END WARNING
  // END WARNING
  // END WARNING

  const today = new Date();
  const dateOfDay = new Date(
    props.date.substring(0, 4) +
    "-" +
    props.date.substring(4, 6) +
    "-" +
    props.date.substring(6, 8)
  );

  // implement this later to properly activate / deactivate the day according to the time
  // implement this later to properly activate / deactivate the day according to the time
  // implement this later to properly activate / deactivate the day according to the time
  // implement this later to properly activate / deactivate the day according to the time
  useEffect(() => {
    if (dateIsTomorrow(dateOfDay)) {
      const interval = setInterval(() => {
        if (!timeNeedsUpdate) setTimeNeedsUpdate(true);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, []);

  useEffect(() => {
    if (timeNeedsUpdate) {
      updateTimeLeft();
      setTimeNeedsUpdate(false);
    }
  }, [timeNeedsUpdate]);

  const updateTimeLeft = () => {
    let timeleft = order_time_limit - today.getHours();
    if (timeleft == 1 && isTomorrow) {
      // (less then) 1 hour left and this day is today
      let now = new Date();
      let t_left = 60 - now.getMinutes();

      if (t_left <= 0 && !disableDayOnTimer) {
          setDisableDayOnTimer(true)
          // go get data again
          dispatch(orderdata_fetchData(true, scheduledata.selectedWeekNumber));
      }
      if (timeLeftToday != t_left) {
        console.log("DO update timeleft", timeLeftToday, t_left);
        setTimeLeftToday(t_left);
      }
    } else {
      if (timeLeftToday != 60) setTimeLeftToday(60);
    }
  };

  // check if date is in past
  // check if date is in past
  // check if date is in past
  const dateInFuture = (firstDate, secondDate) => {
    return (
      new Date(firstDate).setHours(0, 0, 0, 0) >
      new Date(secondDate).setHours(0, 0, 0, 0)
    );
  };

  const allowLocationDate = () => {
    const cutoffDate = new Date(2024, 5, 19); // Months are 0-indexed, so 5 represents June
    if (dateOfDay < cutoffDate) {
      return false;
    } else {
      return true;
    }
  }

  const dateIsTomorrow = date => {

    let weekOfDate = calculateCurrentWeek(date);
    let currentWeek = calculateCurrentWeek();

    let tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
    if (
      new Date(date).setHours(0, 0, 0, 0) ===
      new Date(tomorrow).setHours(0, 0, 0, 0)

      ||
      // today is friday and the date to check is a monday
      // the day to check is in the the next week
      (date.getDay() == 1 && today.getDay() == 5 && weekOfDate == currentWeek + 1)
    )
      return true;
    else return false;
  };

  const mondayClosedForWeekend = date => {

    if (date.getDay() !== 1) {
      return false;
    }

    // Monday ordering closes at the previous Friday cutoff time.
    let fridayCutoff = new Date(date);
    fridayCutoff.setDate(date.getDate() - 3);
    fridayCutoff.setHours(order_time_limit, 0, 0, 0);

    return new Date().getTime() >= fridayCutoff.getTime();
  }

  const weekendOrAfterHolidayClosedFriday = date => {
    const dayOfWeek = date.getDay();
    
    // Check if it's a weekend (Saturday = 6, Sunday = 0)
    if (dayOfWeek === 0 || dayOfWeek === 6) {
      return true;
    }
    
    // Check if it's Monday and ordering has closed after Friday cutoff
    if (dayOfWeek === 1) {
      return mondayClosedForWeekend(date);
    }
    
    return false;
  }

  let inFuture = dateInFuture(dateOfDay, today);
  let isTomorrow = dateIsTomorrow(dateOfDay);
  let weekendOrHolidayClosed = weekendOrAfterHolidayClosedFriday(dateOfDay);
  // disable past days (and today)
  if (!inFuture) {
    {
      console.log("orderday, day not in future");
    }
    if (!dayDisabled) setDayDisabled(true);
  } else {
    // disable tomorrow if the time has passed
    let hours = today.getHours();
    let tolate = hours >= order_time_limit ? true : false;

    if (isTomorrow && (tolate || disableDayOnTimer)) {
      if (!dayDisabled) setDayDisabled(true);
    } else if (weekendOrHolidayClosed) {
      if (!dayDisabled) setDayDisabled(true);
    } else {
      if (dayDisabled) setDayDisabled(false);
    }
  }

  // set the timeleft for tomorrow
  updateTimeLeft();

  // end check if date is in past
  // end check if date is in past
  // end check if date is in past

  // readable date for display
  // readable date for display
  // readable date for display
  let readableDate =
    props.date.substring(6, 8) +
    "/" +
    props.date.substring(4, 6) +
    "/" +
    props.date.substring(0, 4);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOrderUpdate = params => {
    console.log("checkbox", params, props.menus, props.orders);

    dispatch(
      orderdata_updateGroupOrderForDay({
        weeknumber: props.weeknumber,
        date: props.date
      })
    );
  };

  const handleAddOrder = () => {
    handleOrderUpdate({});
  };

  return (
    <React.Fragment>
      <Card className="pb-2">
        <div className="container-fluid no-breadcrumb chapter FormIntegration pt-2 pb-2">
          <Grid container justify="space-between">
            {/* header */}
            {/* header */}
            {/* header */}
            {/* header */}
            <Grid item xs={6}>
              <div className="mt-2 mb-4">
                <b>{weekdays[props.id]}</b> ({readableDate})
                {timeLeftToday < 60 && timeLeftToday > 0 &&(
                  <span style={{ color: "red" }}>
                    {" "}
                    Time left: {timeLeftToday} minutes
                  </span>
                )}
              </div>
            </Grid>
            {!dayDisabled && ordersAvailable && props.menus && (
              <Grid item xs={12}>
                <div className="mt-2 mb-4 ">
                  <Button

                    variant="outlined"
                    onClick={handleAddOrder}
                    key={"AddOrderbutton"}
                  >
                    Add Order
                  </Button>
                </div>
              </Grid>
            )}

            {ordersAvailable &&
              Object.keys(props.orders).map(key => {
                //Check if User EMP and OrderNo match for editing 
                let tempOrderEmp = parseInt(props.orders[key]['PERSNO']);
                let ownOrderEdit = false
 
                if (tempOrderEmp != undefined && tempOrderEmp == parseInt((getUser()["employeeId"]))){
                  ownOrderEdit = true;
                } 

                if (dayDisabled || (((!getUser()["isAdmin"]) && !ownOrderEdit) && (props.orders[key]['savedToSap']))) {
                  
                  return (
                    <GroupOrdersDayMenuFlat
                      {...props}
                      order={props.orders[key]}>
                    </GroupOrdersDayMenuFlat>
                  )
                }
                return (
                  <GroupOrdersDayMenu
                    {...props}
                    disabled={dayDisabled}
                    key={props.id + "-" + key}
                    order={props.orders[key]}
                    id={key}
                    allowLocation={allowLocationDate()}
                  ></GroupOrdersDayMenu>
                );
              })}
            {!dayDisabled && props.menus && (
              <Grid item xs={12}>
                <div className="mt-2 mb-4 ">
                  <Button

                    variant="outlined"
                    onClick={handleAddOrder}
                    key={"AddOrderbutton"}
                  >
                    Add Order
                  </Button>
                </div>
              </Grid>
            )}
          </Grid>
        </div>
      </Card>
      <Modal
        key={"modal"}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Allergies for this Menu:
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {Object.keys(allergiesForMenu).map(key => {
              return (
                <div>
                  ({key}) : {allergiesForMenu[key]}
                </div>
              );
            })}
          </Typography>
        </Box>
      </Modal>
    </React.Fragment>
  );

  /* return Object.keys(props.menus).map(key => {
    if(key.includes("_NUMB") && parseInt(props.menus[key]) > 0){
      return <div>available menu: {props.mappedMenus[parseInt(props.menus[key])]["MENU_DE"]}</div>
    }
  }); */
}

export default GroupOrdersDay;
